import mapNestedNotifications from '../mapNestedNotifications'

export default function(data) {
  return {
    conflictedCounter: data.conflictedCounter,
    counter: data.counter,
    notifications: mapNestedNotifications(data.notifications),
  }
}
